import { render, staticRenderFns } from "./CreateRequest.vue?vue&type=template&id=455acec8"
import script from "./CreateRequest.vue?vue&type=script&lang=js"
export * from "./CreateRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports